import React, { useState } from "react";
import { useSelector } from "react-redux";
import CloseModalIcon from "../../assets/icons/CloseModalIcon";
import { sendCateringPackage } from "../../api/post/sendCateringPackageApi";
import { selectCateringRestaurantId } from "../../redux/features/restaurants/restaurantSelectors";

const SharePackageDetailsModal = ({ onClose }) => {
  const cateringRestaurantId = useSelector(selectCateringRestaurantId);
  const [selectedChannel, setSelectedChannel] = useState(null); // 'sms', 'email', 'whatsapp', or null
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSmsClick = () => {
    setSelectedChannel("sms");
    setPhoneNumberError("");
    setEmailError("");
  };

  const handleWhatsAppClick = () => {
    setSelectedChannel("whatsapp");
    setPhoneNumberError("");
    setEmailError("");
  };

  const handleEmailClick = () => {
    setSelectedChannel("email");
    setPhoneNumberError("");
    setEmailError("");
  };

  const handleSend = async () => {
    if (!cateringRestaurantId) {
      console.error("No catering restaurant ID available");
      return;
    }

    setIsLoading(true);
    
    try {
      if (selectedChannel === "sms") {
        const phoneRegex = /^\d{8}$/;
        if (!phoneRegex.test(phoneNumber)) {
          setPhoneNumberError("Phone number must be exactly 8 digits");
          setIsLoading(false);
          return;
        }

        const sendData = {
          send_as: "sms",
          mobile_country_code: "965",
          mobile_no: phoneNumber,
          email: ""
        };

        await sendCateringPackage(cateringRestaurantId, sendData);
        console.log("SMS sent successfully to:", phoneNumber);
        
      } else if (selectedChannel === "whatsapp") {
        const phoneRegex = /^\d{8}$/;
        if (!phoneRegex.test(phoneNumber)) {
          setPhoneNumberError("Phone number must be exactly 8 digits");
          setIsLoading(false);
          return;
        }

        const sendData = {
          send_as: "whatsapp",
          mobile_country_code: "965",
          mobile_no: phoneNumber,
          email: ""
        };

        await sendCateringPackage(cateringRestaurantId, sendData);
        console.log("WhatsApp sent successfully to:", phoneNumber);
        
      } else if (selectedChannel === "email") {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
          setEmailError("Please enter a valid email address");
          setIsLoading(false);
          return;
        }

        const sendData = {
          send_as: "email",
          mobile_country_code: "",
          mobile_no: "",
          email: email
        };

        await sendCateringPackage(cateringRestaurantId, sendData);
        console.log("Email sent successfully to:", email);
      }

      onClose(); // Close modal after successful sending
    } catch (error) {
      console.error("Failed to send catering package details:", error);
      // You could show an error message to the user here
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 relative w-[439px] h-[320px] shadow-lg flex flex-col justify-center items-center">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          <CloseModalIcon className="w-7 h-7" />
        </button>

        {selectedChannel === null ? (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-center text-xl font-bold text-gray-700 mb-6">
              Share package details.
              <br />
              Choose channel to share.
            </h2>

            <div className="flex flex-col space-y-4 w-[280px]">
              <button
                onClick={handleSmsClick}
                className="w-full py-3 border border-gray-300 rounded-md text-gray-700 font-semibold text-lg hover:bg-gray-100 transition-colors"
              >
                SMS
              </button>
              {/* <button
                onClick={handleWhatsAppClick}
                className="w-full py-3 border border-gray-300 rounded-md text-gray-700 font-semibold text-lg hover:bg-gray-100 transition-colors"
              >
                WhatsApp
              </button>
              <button
                onClick={handleEmailClick}
                className="w-full py-3 border border-gray-300 rounded-md text-gray-700 font-semibold text-lg hover:bg-gray-100 transition-colors"
              >
                E-Mail
              </button> */}
            </div>
          </div>
        ) : selectedChannel === "sms" || selectedChannel === "whatsapp" ? (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-center text-xl font-bold text-gray-700 mb-6">
              Enter the details to share.
            </h2>

            <div className="flex justify-center items-start space-x-2 w-[280px]">
              <input
                type="text"
                readOnly
                value="+965"
                className="w-24 px-4 border border-gray-300 rounded-md text-center text-lg font-semibold text-gray-700 bg-gray-100 focus:outline-none h-12"
              />
              <div className="flex-1 relative pb-10">
                <input
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                    setPhoneNumber(numericValue);
                    setPhoneNumberError("");
                  }}
                  className="w-full py-3 px-4 border border-gray-300 rounded-md text-lg font-semibold text-gray-700 focus:outline-none focus:border-blue-400 h-12"
                />
                {phoneNumberError && (
                  <p className="text-red-500 text-sm absolute bottom-0 left-0">
                    {phoneNumberError}
                  </p>
                )}
              </div>
            </div>

            <button
              onClick={handleSend}
              disabled={isLoading}
              className="w-[280px] py-3 bg-[#86604D] text-white font-semibold text-lg rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Sending..." : "Send"}
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center w-full">
            <h2 className="text-center text-xl font-bold text-gray-700 mb-6">
              Enter the details to share.
            </h2>

            <div className="flex flex-col w-[280px] relative pb-10">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
                className="w-full py-3 px-4 border border-gray-300 rounded-md text-lg font-semibold text-gray-700 focus:outline-none focus:border-blue-400 h-12"
              />
              {emailError && (
                <p className="text-red-500 text-sm absolute bottom-0 left-0">
                  {emailError}
                </p>
              )}
            </div>

            <button
              onClick={handleSend}
              disabled={isLoading}
              className="w-[280px] py-3 bg-[#86604D] text-white font-semibold text-lg rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? "Sending..." : "Send"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SharePackageDetailsModal; 